export const GET_SYSTEMS = 'providers/Systems/GET_SYSTEMS';
export const GET_ALL_SYSTEMS = 'providers/Systems/GET_ALL_SYSTEMS';
export const GET_CONSUMERS = 'providers/Systems/GET_CONSUMERS';
export const CREATE_SYSTEM = 'providers/Systems/CREATE_SYSTEM';
export const EDIT_SYSTEM = 'providers/Systems/EDIT_SYSTEM';
export const DELETE_SYSTEM = 'providers/Systems/DELETE_SYSTEM';